export default {
  buttons: {
    start: 'Começar a preparar encomenda agendada',
  },
};
